import React from 'react';
import { supplierStatusTone } from '../../../utils/supplierStatusDisplay';

export function SupplierStatusBadge({ supplierStatus, showCanonical = true }) {
  if (!supplierStatus?.raw && !supplierStatus?.label) return null;
  const tone = supplierStatusTone(supplierStatus.bucket);
  return (
    <span className={`inline-flex flex-wrap items-center gap-1.5 text-[10px] font-semibold uppercase px-2 py-0.5 rounded border ${tone}`}>
      <span title={supplierStatus.raw_field || 'supplier'}>{supplierStatus.raw || '—'}</span>
      {showCanonical && supplierStatus.canonical && (
        <span className="opacity-75 font-normal normal-case">· {supplierStatus.canonical}</span>
      )}
    </span>
  );
}

export default function SupplierStatusPanel({ supplierStatus }) {
  if (!supplierStatus) return null;
  const perPax = supplierStatus.per_pax || {};
  const paxKeys = Object.keys(perPax);

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4 space-y-3" data-testid="supplier-status-panel">
      <p className="text-[10px] uppercase font-bold text-gray-500 tracking-wide">Supplier status (API)</p>
      <div className="flex flex-wrap items-center gap-2">
        <SupplierStatusBadge supplierStatus={supplierStatus} />
        {supplierStatus.label && supplierStatus.label !== supplierStatus.raw && (
          <span className="text-xs text-gray-600">{supplierStatus.label}</span>
        )}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-xs">
        <div><span className="text-gray-500">Source</span><div className="font-medium">{supplierStatus.source}</div></div>
        <div><span className="text-gray-500">Field</span><div className="font-mono text-[10px]">{supplierStatus.raw_field || '—'}</div></div>
        <div><span className="text-gray-500">Bucket</span><div className="font-medium">{supplierStatus.bucket}</div></div>
        <div><span className="text-gray-500">Synced</span><div className="font-medium">{supplierStatus.last_synced_at ? new Date(supplierStatus.last_synced_at).toLocaleString() : '—'}</div></div>
      </div>
      {supplierStatus.amendment?.raw && (
        <div className="text-xs bg-amber-50 border border-amber-200 rounded-lg p-2">
          Amendment: <span className="font-mono font-semibold">{supplierStatus.amendment.raw}</span>
          {supplierStatus.amendment.is_open && <span className="text-amber-800 ml-2">(open)</span>}
        </div>
      )}
      {paxKeys.length > 0 && (
        <div>
          <p className="text-[10px] text-gray-500 uppercase mb-1">Per passenger (statusMap)</p>
          <div className="space-y-1">
            {paxKeys.map((k) => (
              <div key={k} className="flex justify-between text-xs bg-gray-50 rounded px-2 py-1">
                <span>{k}</span>
                <span className="font-mono font-semibold">{perPax[k]}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
